import { render, staticRenderFns } from "./SalesByCommissionPayPeriodCharts.vue?vue&type=template&id=5063c909&"
import script from "./SalesByCommissionPayPeriodCharts.vue?vue&type=script&lang=ts&"
export * from "./SalesByCommissionPayPeriodCharts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCard,VSelect,VSwitch})
